export const steps = ['Dados de contato', 'Um pouco mais sobre sua empresa', 'Login e senha'];
